import { useMemo } from 'react';

export const useTimelineData = (rawData) => {
    const timelineData = useMemo(() => {
        if (!rawData?.pages) return [];

        const seenKeys = new Set();
        return rawData.pages.flatMap((group, groupIndex) =>
            group?.data?.data?.map((item, itemIndex) => {
                const uniqueKey = `${groupIndex}-${itemIndex}-${item.datetime}-${item.summary}`;
                if (seenKeys.has(uniqueKey)) return null;
                seenKeys.add(uniqueKey);
                return { ...item, uniqueKey };
            }).filter(Boolean) || []
        );
    }, [rawData]);

    return { timelineData };
};